


import PropTypes from "prop-types";
import { useSpring, animated, config } from 'react-spring';
export const FintechItem = ({image, titleheader,title}) => {
    const props = useSpring({
        loop: true, // Lặp lại vô hạn
        from: { transform: 'scale(1)' }, // Kích thước ban đầu
        to: { transform: 'scale(1.5)' }, // Kích thước sau khi zoom
        config: { duration: 2000 }, // Tùy chỉnh cấu hình animation (có thể thay đổi)
      });
    return (
        <div className="flex flex-col items-center">
                        <animated.img style={props} src={image}/>
                        <div>
                            <h3 className="text-[--color-hover] text-center text-[24px] font-bold">{titleheader}</h3>
                            <p className="text-4 max-w-[406px] sm:max-w-none text-center text-[--color-text]">{title}</p>
                        </div>
                    </div>
    )
}
FintechItem.propTypes = {
    image: PropTypes.string,
    titleheader: PropTypes.string,
    title: PropTypes.string,
    
  };